export default [
  {
    path: "/p0d012e321290b03a7c08cda9e5f850a43cas/:er?",
    name: "baice26.photoAlbum",
    component: () => import("@/views/baice/tws/photoalbum/index.vue"),
    meta: {
      title: "Print 2026 BAICE PhotoAlbum",
      authRequired: true,
      acc: ["y98978"],
    },
  },
  {
    path: "/pri0d24932b2863bfe5f80cee82f783ca5ed1bd77fb9250a43cas",
    name: "baice26.photoAlbums",
    component: () => import("@/views/baice/tws/photoalbum/list.vue"),
    meta: {
      title: "2026 BAICE PhotoAlbum",
      authRequired: true,
      acc: ["y60940"],
    },
  },
];
